import React, { useState, useEffect, useCallback } from 'react';
import { LocalUserChoices } from '@livekit/components-react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import { Logo } from '../Form';
import { ChooseConfiguration } from './ChooseConfiguration';
import { ChooseWebcam } from './ChooseWebcam';
import { ConferenceTest } from './ConferenceTest';
import { Stage } from './enums';
import { initDrift } from './initDrift';
import { IConfigOption } from './types';
import WelcomeStage from './WelcomeScreen/WelcomeStage';

const TestContainer = styled(Box)({
  height: '100vh',
  position: 'fixed',
  width: '100vw',
  overflow: 'auto',
});

export const TestConference = () => {
  const [stage, setStage] = useState(Stage.Welcome);
  const [configOptions, setConfigOptions] = useState<IConfigOption>();
  const [email, setEmail] = useState<string>();
  const [userChoices, setuserChoices] = useState<LocalUserChoices>();

  useEffect(() => {
    initDrift();
  }, []);

  const handleConfigurationSubmit = useCallback(
    (emailVal: string, config: IConfigOption) => {
      setEmail(emailVal);
      setConfigOptions(config);
      setStage(Stage.ChooseWebcam);
    },
    [],
  );

  const handleNextStep = useCallback((setup: LocalUserChoices) => {
    setuserChoices(setup);
    setStage(Stage.RunTest);
  }, []);

  return (
    <TestContainer>
      {stage === Stage.RunTest && userChoices ? (
        <ConferenceTest
          configOptions={configOptions}
          email={email ?? ''}
          userChoices={userChoices}
        />
      ) : (
        <Container>
          <Box
            className="container-logo"
            sx={{ textAlign: 'center', mt: '50px' }}
          >
            <Logo />
          </Box>

          {stage === Stage.Welcome ? (
            <WelcomeStage setStage={setStage} />
          ) : null}

          {stage === Stage.ChooseConfiguration ? (
            <ChooseConfiguration
              handleConfigurationSubmit={handleConfigurationSubmit}
            />
          ) : null}

          {stage === Stage.ChooseWebcam ? (
            <ChooseWebcam handleNextStep={handleNextStep} />
          ) : null}
        </Container>
      )}
    </TestContainer>
  );
};
